import { render } from "./AustriaPage.vue?vue&type=template&id=5d9580d0&scoped=true"
import script from "./AustriaPage.vue?vue&type=script&lang=js"
export * from "./AustriaPage.vue?vue&type=script&lang=js"

import "./AustriaPage.vue?vue&type=style&index=0&id=5d9580d0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d9580d0"]])

export default __exports__